import { render, staticRenderFns } from "./SuperAdminUserCreate.vue?vue&type=template&id=54a95ac6"
import script from "./SuperAdminUserCreate.vue?vue&type=script&lang=js"
export * from "./SuperAdminUserCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports